import { refs, domReady, dispatchEvent } from '../modules/utils.js';

class MobileMenu extends HTMLElement {
  static get observedAttributes() {
    return ['data-active'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-active') {
      const isActive = this.hasAttribute('data-active');
      dispatchEvent(isActive ? 'mobilemenu:opened' : 'mobilemenu:closed');
      if (isActive) {
        document.documentElement.setAttribute('data-unscrollable', '');
      }
      else {
        document.documentElement.removeAttribute('data-unscrollable');
      }
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#setListeners();
  }

  #setListeners() {
    document.addEventListener('topbar:mobilemenu', () => {
      this.toggleAttribute('data-active');
    });
  }
}

customElements.define('mobile-menu', MobileMenu);
